module.exports = __webpack_public_path__ + "img/caja-trujillo.58d4db03.svg";